import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';
import WindowBrowser from "../components/browser-window";

const Inclusivity = () => {
    useEffect(() => {
        // Any animations or side effects can be added here
    }, [])

    return (
        <div className="simple_page">
            <div className="mainIntro">
                <h1>Inclusivity</h1>
                <h3>Spot the fake. Safeguard the cure.</h3>
            </div>

            <div class="max-w-2xl mx-auto mt-8">
                <div class="w-full h-11 rounded-t-lg bg-gray-900 flex justify-start items-center space-x-1.5 px-3">
                    <span class="w-3 h-3 rounded-full bg-red-400"></span>
                    <span class="w-3 h-3 rounded-full bg-yellow-400"></span>
                    <span class="w-3 h-3 rounded-full bg-green-400"></span>
                </div>
                <div class="bg-gray-700 border-t-0 w-full h-96"></div>
            </div>

            <section className="divider">
                <div className="fixed_sidebar">
                    <div className="sidebar">
                        <div className="main_sidebar">
                            Inclusivity
                        </div>

                        <Scrollspy
                            offset={-140}
                            className="scrollspy" items={['Building_team', 'Inclusive_Collab_Comms', 'Inclusive_Outreach_Impact', 'Inclusivity_in_Action', 'Impact_and_Feedback']}
                            currentClassName="active">
                            <li><a href="#Building_team">Building a Diverse and Inclusive Team</a></li>
                            <li><a href="#Inclusive_Collab_Comms">Inclusive Collaboration and Communication</a></li>
                            <li><a href="#Inclusive_Outreach_Impact">Inclusive Outreach and Impact</a></li>
                            <li><a href="#Inclusivity_in_Action">Stories of Inclusivity in Action</a></li>
                            <li><a href="#Impact_and_Feedback">Impact and Feedback</a></li>


                        </Scrollspy>

                        <img
                            src="https://static.igem.wiki/teams/5334/wiki-images/updated-mascot/mascot-lying-down-3.webp"
                            alt="Mascot lying down"

                        />
                    </div>
                </div>

                <div className="main_lab_style">
                    <WindowBrowser header="🌍 United by Diversity, Driven by Inclusivity 🌍" description={
                        <div>
                            <p>
                                Our team is a vibrant mosaic of cultures and expertise, bringing together members from Kyrgyzstan, South Korea, Russia, Belarus, China, Indonesia, Pakistan, and Hong Kong. We believe that tackling global challenges like counterfeit cancer drugs requires diverse perspectives and inclusive collaboration. Each of us brings a unique background and set of skills, which together create a powerful force for innovation.
                            </p>
                            <img src="https://static.igem.wiki/teams/5334/wiki-images/team/inclusivity.jpg"></img>


                            <section id="Building_team">
                                <br />
                                <h1>
                                    Building a Diverse and Inclusive Team
                                </h1>
                                <p>Inclusivity has been a fundamental principle from the beginning of our team’s journey. While all our members come from the same university, we worked hard to ensure our team reflects a broad spectrum of perspectives and experiences. We actively engage with diverse student communities on campus to foster an inclusive environment, ensuring that our project benefits from a wide range of insights and ideas.

                                </p>
                                <img style={{ borderRadius: '50px'}} src="https://static.igem.wiki/teams/5334/wiki-images/team/whole-team-in-hoodies.webp"></img>
                                <p>
                                    To accommodate the diverse needs of our team members, we implemented flexible work schedules that respect different time zones and personal commitments. This flexibility has been crucial in allowing everyone to contribute effectively. Additionally, we established equal opportunities for growth, with a transparent process for role assignments and regular meetings to help members explore their interests and enhance their skills.
                                </p>
                                <p>
                                <strong>Our team wearing is a custom-made hoodies designed by our members:</strong>
                                </p>
                                <img style={{ 
                                    borderRadius: '50px',

                                    }}src="https://static.igem.wiki/teams/5334/wiki-images/team/team-in-hoodies.jpg">
                                </img>
                               
                            </section>


                            <section id="Inclusive_Collab_Comms">
                                <br />
                                <h1>
                                    Inclusive Collaboration and Communication
                                </h1>
                                <p>
                                    Creating an inclusive environment means more than just bringing together a diverse team; it involves fostering a culture where every voice is heard and valued. We adopted several strategies to promote open communication and collaboration, including weekly feedback sessions where team members can share their thoughts and suggestions. These sessions ensure that everyone feels comfortable voicing their opinions and that their feedback is actively incorporated into our project planning and execution.
                                </p>
                                <p>
                                    We also organized cultural competency workshops to enhance mutual understanding and respect among team members. These workshops helped us navigate different cultural norms and practices, promoting a more harmonious and effective working environment. To support seamless communication, we utilized collaborative tools like MS Teams and Zoom, which facilitated real-time collaboration regardless of location.
                                </p>
                            </section>

                            <section id="Inclusive_Outreach_Impact">
                                <br />
                                <h1>
                                    Inclusive Outreach and Impact
                                </h1>
                                <p>
                                    Our commitment to inclusivity extends beyond our team to the communities we engage with. We strive to make science accessible to everyone, especially those from underrepresented or marginalized backgrounds. Our educational outreach initiatives are designed to reach a diverse audience, from high school students to university students and even young children.
                                </p>

                                <h2>
                                    Engaging High School Students:
                                </h2>
                                <p>
                                    We organized an online talk titled "Biohacking for a Better World," reaching students from eleven countries. The event introduced participants to synthetic biology and our project on detecting counterfeit cancer drugs. Interactive elements like Kahoot games kept the participants engaged and helped them better understand the material. (Find more activities <a href="https://2024.igem.wiki/cityu-hongkong/education#HSchool">on the Education page: section <strong>High School Students</strong></a>).
                                </p>

                                <h2>
                                    Outreach to University Students:
                                </h2>
                                <p>
                                    For university students, we developed an Integrated Human Practices (IHP) Handbook and an Ethics Handbook in collaboration with Queen’s University. These resources emphasized the importance of ethical considerations and societal impacts in synthetic biology, guiding students to embark on similar projects.  (Find more activities <a href="https://2024.igem.wiki/cityu-hongkong/education#University_General_Public">on the Education page: section <strong>University Students and General Public</strong></a>).
                                </p>

                                <h2>
                                    Introducing Children to Synthetic Biology:
                                </h2>
                                <p>
                                    Understanding the importance of early education, we organized a workshop called "Adventure to the Field of Biology" for children aged 4-6 in collaboration with the Hong Kong Children’s Foundation. The workshop, conducted in multiple languages, used fun and engaging activities like DNA origami and play dough cell models to introduce basic biological concepts. (Find more activities <a href="https://2024.igem.wiki/cityu-hongkong/education#Children">on the Education page: section <strong>Children</strong></a>).
                                </p>

                                <h2>
                                    Creating an Inclusive Online Presence
                                </h2>
                                <p>
                                    In today’s digital age, ensuring that our online platforms are accessible is paramount. We took several steps to make our wiki page and other digital resources inclusive. This includes designing our website to be compatible with screen readers, using high-contrast color schemes for better visibility, and selecting sans-serif fonts and large headings for improved readability. We also ensured that our promotional videos included subtitles in multiple languages, making our content accessible to a global audience.
                                </p>
                            </section>

                            <section id="Inclusivity_in_Action">
                                <br />


                                <h1>
                                    Stories of Inclusivity in Action
                                </h1>

                                <h2>Sharing Our Innovations:</h2>
                                <p>
                                    We produced a video in collaboration with Washington University, showcasing our aptamer-based biosensor for detecting counterfeit drugs. The video detailed the SELEX process and other technical aspects of our project, making the science accessible to a broader audience.
                                </p>

                                <h2>
                                    Expanding Accessibility Through Resources:
                                </h2>
                                <p>
                                    Recognizing the lack of synthetic biology workshops in local communities, we created a handbook with detailed instructions and activities for organizing similar workshops globally. The handbook was translated into multiple languages, aiming to make it easier for educators to engage students of all ages in synthetic biology.
                                </p>
                            </section>

                            <section id="Impact_and_Feedback">
                                <h1>
                                    Impact and Feedback 💪
                                </h1>
                                <p>
                                    Our inclusive practices have resulted in numerous positive outcomes, both within our team and in the broader community. The diverse perspectives within our team have led to innovative solutions and a dynamic approach to problem-solving. Our outreach initiatives have successfully engaged a wide range of participants, and the feedback we’ve received has been overwhelmingly positive, with many participants expressing gratitude for the accessible and inclusive learning opportunities we provided.
                                </p>

                                <h2>
                                    Conclusion
                                </h2>
                                <p>
                                    In summary, our team has meticulously integrated diversity and inclusivity into every aspect of our project. From building a diverse team and fostering an inclusive work environment to engaging with diverse communities through accessible outreach initiatives, we strive to ensure that our work benefits everyone. Our commitment to inclusivity not only enhances our project’s impact but also creates a welcoming and supportive environment where every member can thrive.
                                </p>
                                <p>
                                    Together, we’re bridging continents, building solutions, and driving change. Our diverse scientific expertise, coupled with our shared vision for a more inclusive future, empowers us to combat the global issue of counterfeit cancer drugs. We are united in our goal to make a lasting impact on global health, and we believe that our differences are what make us stronger.
                                    Join us on this journey as we work towards a safer, more inclusive world through the power of science and collaboration. 

                                </p>

                                <br />
                                <br />
                            </section>



                        </div>
                    } />
                </div>
            </section>
        </div>
    );
};

export default Inclusivity;
